/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 848);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(8)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 848:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ScoreApp = __webpack_require__(849);

var _ScoreApp2 = _interopRequireDefault(_ScoreApp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component(_ScoreApp2.default.name, _ScoreApp2.default);

/***/ }),

/***/ 849:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(850)
  __webpack_require__(852)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(860),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7c0d1483",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 850:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(851);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("29cb21d6", content, true, {});

/***/ }),

/***/ 851:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, "#pg-app .pg-uni-bnr{color:#0aa0d7;line-height:90px;text-align:center;margin-bottom:20px;font-weight:700}#pg-app .pg-linkto-myuniv{margin-bottom:20px}@media (min-width:710px){#pg-app .pg-linkto-myuniv{width:200px}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/myuniv/ScoreApp.vue"],"names":[],"mappings":"AACA,oBAAoB,cAAc,iBAAiB,kBAAkB,mBAAmB,eAAe,CACtG,AACD,0BAA0B,kBAAkB,CAC3C,AACD,yBACA,0BAA0B,WAAW,CACpC,CACA","file":"ScoreApp.vue","sourcesContent":["\n#pg-app .pg-uni-bnr{color:#0aa0d7;line-height:90px;text-align:center;margin-bottom:20px;font-weight:700\n}\n#pg-app .pg-linkto-myuniv{margin-bottom:20px\n}\n@media (min-width:710px){\n#pg-app .pg-linkto-myuniv{width:200px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(853);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("16510d0c", content, true, {});

/***/ }),

/***/ 853:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-offer-head[data-v-7c0d1483]{letter-spacing:-.5em}.my-offer-head>[data-v-7c0d1483]{letter-spacing:normal}.my-offer-meta-list[data-v-7c0d1483],.my-offer-meta[data-v-7c0d1483],.my-offer-name[data-v-7c0d1483],.pg-tab-year-pos[data-v-7c0d1483]{display:inline-block}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/myuniv/ScoreApp.vue"],"names":[],"mappings":"AACA,gCAAgC,oBAAoB,CACnD,AACD,iCAAkC,qBAAqB,CACtD,AACD,uIAAuI,oBAAoB,CAC1J","file":"ScoreApp.vue","sourcesContent":["\n.my-offer-head[data-v-7c0d1483]{letter-spacing:-.5em\n}\n.my-offer-head>*[data-v-7c0d1483]{letter-spacing:normal\n}\n.my-offer-meta[data-v-7c0d1483],.my-offer-meta-list[data-v-7c0d1483],.my-offer-name[data-v-7c0d1483],.pg-tab-year-pos[data-v-7c0d1483]{display:inline-block\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 854:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScoreYear = __webpack_require__(855);

var _ScoreYear2 = _interopRequireDefault(_ScoreYear);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dn-bible-myuniv-score-app',

  components: {
    'my-year': _ScoreYear2.default
  },

  data: function data() {
    var _ref;

    return _ref = {

      // debug
      debug: this.$route.query.debug !== undefined,

      // constants
      displayItemDetailKeys: ['faculty_name', 'department_name', 'schedule_name', 'examination_method_name'],

      // states
      state: 'pending',
      fecthState: 'pending',
      downloadStatus: null,

      // values
      selected: null
    }, _defineProperty(_ref, 'selected', null), _defineProperty(_ref, 'offerId', this.$route.query.offer_id), _defineProperty(_ref, 'offer', null), _ref;
  },


  computed: {

    // refs
    $downloader: function $downloader() {
      return this.$refs.downloader;
    },


    // flags
    hasData: function hasData() {
      return this.downloadStatus ? this.downloadStatus.hasData : false;
    },
    isFetching: function isFetching() {
      return this.fecthState === 'fetching';
    },
    isFetched: function isFetched() {
      return this.fecthState === 'fetched';
    },
    hasFetchError: function hasFetchError() {
      return this.fecthState === 'error';
    },
    baseYear: function baseYear() {
      return this.$store.getters['config/year'];
    },
    years: function years() {
      if (!this.baseYear) return;
      var years = [];
      for (var i = 0; i < 3; i++) {
        years.push(this.baseYear - i - 1);
      }
      return years;
    }
  },

  methods: {
    onDataReady: function onDataReady(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.fetch();

              case 2:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetch: function fetch() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.fecthState = 'fetching';

                _context2.prev = 1;
                _context2.next = 4;
                return dn.db.searchOfferWithPassingScores({ offer_id: _this2.offerId, year: _this2.years });

              case 4:
                _this2.offer = _context2.sent;
                _context2.next = 11;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](1);

                _this2.fecthState = 'error';
                throw new Error(_context2.t0);

              case 11:

                _this2.fecthState = 'fetched';

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 7]]);
      }))();
    },
    getScoreByYear: function getScoreByYear(year) {
      return this.offer.passing_scores.find(function (score) {
        return score.year === year;
      });
    }
  }
};

/***/ }),

/***/ 855:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(859),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-66d1fd4b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 856:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(857);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4a506b0c", content, true, {});

/***/ }),

/***/ 857:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-empty__reference[data-v-66d1fd4b]{margin-top:20px}.my-empty__reference>dt[data-v-66d1fd4b]:before{content:\"\\FF1C\"}.my-empty__reference>dt[data-v-66d1fd4b]:after{content:\"\\FF1E\"}.my-empty__footer[data-v-66d1fd4b]{margin-top:40px}.my-empty__footer>dt[data-v-66d1fd4b]{display:inline-block}.my-empty__footer>dt[data-v-66d1fd4b]:after{content:\"\\FF1A\"}.my-empty__footer>dd[data-v-66d1fd4b]{display:inline-block;white-space:nowrap}.my-block[data-v-66d1fd4b]{margin:10px 0}.my-block__header[data-v-66d1fd4b]{padding:10px 0 7px}.my-box[data-v-66d1fd4b]{border:1px solid #adc4cc;margin:10px 0}.my-box__header[data-v-66d1fd4b]{position:relative;background:#e6f5fa;border-bottom:1px solid #adc4cc;padding:13px 15px;text-align:center}.my-box__icon-self[data-v-66d1fd4b]{position:absolute;right:10px;top:50%;margin-top:-12px}.my-box__body[data-v-66d1fd4b]{padding:10px 15px;text-align:center}.my-annotation[data-v-66d1fd4b]{margin-top:20px}.my-accent-num[data-v-66d1fd4b]{font-weight:700;font-size:18px}.my-color-alert[data-v-66d1fd4b]{background:#ffbdbd}.my-color-success[data-v-66d1fd4b]{background:#cdffbd}.my-wrap[data-v-66d1fd4b]{display:inline-block}.my-single-score-input[data-v-66d1fd4b]{width:76px;text-align:center}.my-empty-score[data-v-66d1fd4b]{display:inline-block;vertical-align:middle;margin-top:.3em}.my-empty-score+.my-empty-icon[data-v-66d1fd4b]{margin-left:5px;margin-right:-30px}.my-linkto-about[data-v-66d1fd4b]{text-align:right}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/bible/myuniv/ScoreYear.vue"],"names":[],"mappings":"AAEA,sCAAsC,eAAe,CACpD,AACD,gDAAgD,eAAW,CAC1D,AACD,+CAA+C,eAAW,CACzD,AACD,mCAAmC,eAAe,CACjD,AACD,sCAAsC,oBAAoB,CACzD,AACD,4CAA4C,eAAW,CACtD,AACD,sCAAsC,qBAAqB,kBAAkB,CAC5E,AACD,2BAA2B,aAAa,CACvC,AACD,mCAAmC,kBAAkB,CACpD,AACD,yBAAyB,yBAAyB,aAAa,CAC9D,AACD,iCAAiC,kBAAkB,mBAAmB,gCAAgC,kBAAkB,iBAAiB,CACxI,AACD,oCAAoC,kBAAkB,WAAW,QAAQ,gBAAgB,CACxF,AACD,+BAA+B,kBAAkB,iBAAiB,CACjE,AACD,gCAAgC,eAAe,CAC9C,AACD,gCAAgC,gBAAgB,cAAc,CAC7D,AACD,iCAAiC,kBAAkB,CAClD,AACD,mCAAmC,kBAAkB,CACpD,AACD,0BAA0B,oBAAoB,CAC7C,AACD,wCAAwC,WAAW,iBAAiB,CACnE,AACD,iCAAiC,qBAAqB,sBAAsB,eAAe,CAC1F,AACD,gDAAgD,gBAAgB,kBAAkB,CACjF,AACD,kCAAkC,gBAAgB,CACjD","file":"ScoreYear.vue","sourcesContent":["\n@charset \"UTF-8\";\n.my-empty__reference[data-v-66d1fd4b]{margin-top:20px\n}\n.my-empty__reference>dt[data-v-66d1fd4b]:before{content:\"＜\"\n}\n.my-empty__reference>dt[data-v-66d1fd4b]:after{content:\"＞\"\n}\n.my-empty__footer[data-v-66d1fd4b]{margin-top:40px\n}\n.my-empty__footer>dt[data-v-66d1fd4b]{display:inline-block\n}\n.my-empty__footer>dt[data-v-66d1fd4b]:after{content:\"：\"\n}\n.my-empty__footer>dd[data-v-66d1fd4b]{display:inline-block;white-space:nowrap\n}\n.my-block[data-v-66d1fd4b]{margin:10px 0\n}\n.my-block__header[data-v-66d1fd4b]{padding:10px 0 7px\n}\n.my-box[data-v-66d1fd4b]{border:1px solid #adc4cc;margin:10px 0\n}\n.my-box__header[data-v-66d1fd4b]{position:relative;background:#e6f5fa;border-bottom:1px solid #adc4cc;padding:13px 15px;text-align:center\n}\n.my-box__icon-self[data-v-66d1fd4b]{position:absolute;right:10px;top:50%;margin-top:-12px\n}\n.my-box__body[data-v-66d1fd4b]{padding:10px 15px;text-align:center\n}\n.my-annotation[data-v-66d1fd4b]{margin-top:20px\n}\n.my-accent-num[data-v-66d1fd4b]{font-weight:700;font-size:18px\n}\n.my-color-alert[data-v-66d1fd4b]{background:#ffbdbd\n}\n.my-color-success[data-v-66d1fd4b]{background:#cdffbd\n}\n.my-wrap[data-v-66d1fd4b]{display:inline-block\n}\n.my-single-score-input[data-v-66d1fd4b]{width:76px;text-align:center\n}\n.my-empty-score[data-v-66d1fd4b]{display:inline-block;vertical-align:middle;margin-top:.3em\n}\n.my-empty-score+.my-empty-icon[data-v-66d1fd4b]{margin-left:5px;margin-right:-30px\n}\n.my-linkto-about[data-v-66d1fd4b]{text-align:right\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var MESSAGES = {
  avg: '平均',
  min: '最低',
  emptyScore: '***'
};

exports.default = {
  props: {
    year: {
      type: [String, Number],
      required: true
    },
    offer: {
      type: Object,
      required: true
    },
    score: {
      type: Object,
      default: null
    }
  },

  data: function data() {
    return {
      MESSAGES: MESSAGES,
      subjectsState: 'pending',
      inputSingleScore: {}
    };
  },


  computed: {
    subjectsStoreName: function subjectsStoreName() {
      return 'selfcheck-' + this.year;
    },
    subjectsIsReady: function subjectsIsReady() {
      return this.subjectsState === 'loaded';
    },
    totalHistory: function totalHistory() {
      return this.$store.getters[this.subjectsStoreName + '/totalHistory'];
    },


    /**
     * 表示パターン
     *   (1) center. 満点（センター）があって、かつ最低点（センター）、平均点（センター）のいずれかがある場合
     *   (2) total . 満点（個別）、満点（総合）があって、最低点（総合）、平均点（総合）のいずれかがある場合
     *   (3) empty . レコード自体がない、または上記のどの条件にも一致しない
     */
    pattern: function pattern() {
      if (!this.score) return 'empty';
      if (this.hasCenterScore) return 'center';
      if (this.hasTotalScore) return 'total';
      return 'empty';
    },
    isCenter: function isCenter() {
      return this.pattern === 'center';
    },
    isTotal: function isTotal() {
      return this.pattern === 'total';
    },
    isEmpty: function isEmpty() {
      return this.pattern === 'empty';
    },
    hasTotals: function hasTotals() {
      return this.subjectsIsReady && this.totalHistory.per !== null;
    },


    // 満点（センター）があって、かつ最低点（センター）、平均点（センター）のいずれかがあるか
    hasCenterScore: function hasCenterScore() {
      return this.hasScore('center_max') && this.hasAnyScore('center_min', 'center_avg');
    },


    // 満点（個別）、満点（総合）があって、最低点（総合）、平均点（総合）のいずれかがある場合
    hasTotalScore: function hasTotalScore() {
      return this.hasScore('single_max', 'total_max') && this.hasAnyScore('total_min', 'total_avg');
    },


    // 大学コード
    university_id: function university_id() {
      return this.offer.id.slice(0, 4);
    },


    // 学部コード
    faculty_id: function faculty_id() {
      return this.offer.id.slice(4, 6);
    },


    // 合格目標ラインのリンク先
    goalLineUrl: function goalLineUrl() {
      return this.$store.getters['path/yearRoot'](this.year) + ('/doukou/goukaku/' + this.university_id + '/' + this.faculty_id + '.html');
    },


    // 平均点情報のリンク先
    avgScoreInfoUrl: function avgScoreInfoUrl() {
      return this.$store.getters['path/yearRoot'](this.year) + '/sokuhou/yosou/index.html';
    },


    // (1) center用のデータ
    centerData: function centerData() {
      var data = { max: this.getScore('center_max') };

      var _arr = ['avg', 'min'];
      for (var _i = 0; _i < _arr.length; _i++) {
        var key = _arr[_i];
        data[key] = null;
        var score = this.getScore('center_' + key);
        if (score === null) continue;
        data[key] = {
          score: score,
          per: score / data.max,
          need: null
        };

        if (this.hasTotals) {
          data[key].need = Math.round(this.totalHistory.max * data[key].per - this.totalHistory.score);
        }
      }

      return data;
    },


    // (2) total用のデータ
    totalData: function totalData() {
      var data = { max: this.getScore('total_max'), singleMax: this.getScore('single_max') };

      var _arr2 = ['avg', 'min'];
      for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
        var key = _arr2[_i2];
        data[key] = null;
        var score = this.getScore('total_' + key);
        if (score === null) continue;
        data[key] = {
          score: score,
          need: score - (this.totalHistory && this.totalHistory.score || 0) - (this.inputSingleScore[key] || 0)
        };
      }

      return data;
    },


    // 自身のコンポーネント表示に必要なデータを表示パターンに応じて振り分け参照する
    mydata: function mydata() {
      if (this.isCenter) {
        return this.centerData;
      } else if (this.isTotal) {
        return this.totalData;
      }
    },
    selfUrl: function selfUrl() {
      return this.$store.getters['path/yearRoot'](this.year) + '/jikosaiten/index.html';
    },
    singleScoreLsKeySuf: function singleScoreLsKeySuf() {
      return 'offer_single_score_' + this.offer.id + '_' + this.year + '_';
    }
  },

  methods: {

    /**
     * 得点データを参照する
     */
    getScore: function getScore(key) {
      var score = this.score['score_' + key];
      return score === undefined ? null : score;
    },


    /**
     * 全ての引数の得点データが存在するかチェック
     */
    hasScore: function hasScore() {
      for (var _len = arguments.length, keys = Array(_len), _key = 0; _key < _len; _key++) {
        keys[_key] = arguments[_key];
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          if (this.getScore(key) === null) {
            return false;
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return true;
    },


    /**
     * 引数のうちのいずれかの得点データが存在するかチェック
     */
    hasAnyScore: function hasAnyScore() {
      for (var _len2 = arguments.length, keys = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        keys[_key2] = arguments[_key2];
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          if (this.hasScore(key)) {
            return true;
            break;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return false;
    },


    /**
     * 科目情報モデルをロードする
     */
    initSubjects: function initSubjects() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.subjectsState = 'loading';
                _context.next = 3;
                return _this.$store.dispatch('loadSelfcheck', _this.year);

              case 3:
                _this.subjectsState = 'loaded';

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },


    /**
     * 個別入力点数変更時のコールバック
     * （ローカルストレージに保存する）
     */
    onChangeSingleScore: function onChangeSingleScore(e, key) {
      var el = e.target,
          value = parseInt(el.value);

      if (isNaN(value)) value = null;

      var lsKey = this.singleScoreLsKeySuf + key;
      this.$ls.set(lsKey, value);
    },


    /**
     * ローカルストレージから個別入力点数を復元する
     */
    restoreSingleScoreFromLs: function restoreSingleScoreFromLs() {
      var _this2 = this;

      ['avg', 'min'].forEach(function (key) {
        var lsKey = _this2.singleScoreLsKeySuf + key,
            value = _this2.$ls.get(lsKey, null);

        _this2.$set(_this2.inputSingleScore, key, value);
      });
    },


    /**
     * 自己採点ダイアログを表示する
     */
    showSelfCheckDialog: function showSelfCheckDialog() {
      return this.$refs.selfCheckDialog.show();
    },


    /**
     * 「表の見方はこちら」ウィンドウを表示する
     */
    showAboutWindow: function showAboutWindow(type) {
      return window.open('./about' + type + '.html', 'dn-bible-myuniv-about-' + type, 'width=600, height=560, menubar=no, toolbar=no, scrollbars=yes');
    }
  },

  filters: {
    score: function score(_score) {
      var value = typeof _score === 'number' ? _score : parseInt(_score, 10);
      if (isNaN(value)) return _score;
      return Math.round(value);
    }
  },

  created: function created() {
    var _this3 = this;

    this.initSubjects();

    // ローカルストレージから個別入力点数を復元
    // ※ウォッチャも設定しておく
    this.restoreSingleScoreFromLs();
    dn.window.on('show', function () {
      _this3.restoreSingleScoreFromLs();
    });
  }
};

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pg-year"
  }, [(_vm.isEmpty) ? _c('div', {
    staticClass: "my-empty"
  }, [_c('p', [_vm._v("大学が公表している合格者得点がありません。")]), _vm._v(" "), _c('dl', {
    staticClass: "my-empty__reference"
  }, [_c('dt', [_vm._v("参考情報")]), _vm._v(" "), _c('dd', [_vm._v("合格目標ラインは"), _c('a', {
    attrs: {
      "href": _vm.goalLineUrl,
      "target": "_blank"
    }
  }, [_vm._v("こちら")]), _vm._v("をご確認ください。"), _c('br'), _vm._v("※合格目標ラインがない大学は表示されません。")])]), _vm._v(" "), _vm._m(0)]) : _c('div', [_c('section', [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("センター試験の目標得点シミュレーション")]), _vm._v(" "), _c('p', {
    staticClass: "my-linkto-about"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "anchor"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "vam",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showAboutWindow(_vm.isCenter ? '1' : '2')
      }
    }
  }, [_vm._v("表の見方はこちら")])], 1), _vm._v(" "), _vm._l((['avg', 'min']), function(dataKey) {
    return _c('div', {
      key: dataKey,
      staticClass: "my-block"
    }, [_c('h4', {
      staticClass: "my-block__header mdTtl05"
    }, [_vm._v("【合格者" + _vm._s(_vm.MESSAGES[dataKey]) + "点の得点" + _vm._s(_vm.isCenter ? '率' : '') + "を目標にした場合】")]), _vm._v(" "), (!_vm.mydata[dataKey]) ? _c('p', [_vm._v("大学が公表している合格者の" + _vm._s(_vm.MESSAGES[dataKey]) + "点はありません。")]) : _c('div', [(_vm.isCenter) ? _c('div', [_c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("合格者" + _vm._s(_vm.MESSAGES[dataKey]) + "得点率")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [_c('span', {
      staticClass: "my-wrap"
    }, [_c('span', {
      staticClass: "my-accent-num"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].per * 100)))]), _vm._v("%")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("（" + _vm._s(_vm._f("score")(_vm.mydata[dataKey].score)) + "点/" + _vm._s(_vm.mydata.max) + "点）")])])]), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("\n                あなたの自己採点得点率\n                "), _c('dn-icon', {
      staticClass: "my-box__icon-self",
      attrs: {
        "icon": "self",
        "btn": "",
        "href": _vm.selfUrl,
        "target": "_blank",
        "title": (_vm.year + "年度 自己採点")
      }
    })], 1), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [(_vm.hasTotals) ? _c('div', [_c('span', {
      staticClass: "my-wrap"
    }, [_c('span', {
      staticClass: "my-accent-num"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.totalHistory.per * 100)))]), _vm._v("%")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("（" + _vm._s(_vm.totalHistory.score) + "点/" + _vm._s(_vm.totalHistory.max) + "点）")])]) : _c('div', [_c('span', {
      staticClass: "my-empty-score"
    }, [_vm._v(_vm._s(_vm.MESSAGES.emptyScore))]), _vm._v(" "), _c('dn-icon', {
      staticClass: "my-empty-icon",
      attrs: {
        "icon": "question",
        "btn": "",
        "title": "自己採点について"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showSelfCheckDialog($event)
        }
      }
    })], 1)])]), _vm._v(" "), _c('hr', {
      staticClass: "dn-divider-tri--down"
    }), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("センター試験であと何点伸ばそう")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body my-accent-num",
      class: ( _obj = {}, _obj[("my-color-" + (_vm.mydata[dataKey].need <= 1 && _vm.mydata[dataKey].need !== null ? 'success' : 'alert'))] = true, _obj )
    }, [(_vm.hasTotals) ? _c('div', [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].need)) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.totalHistory.max) + "点")])]) : _c('div', [_c('span', {
      staticClass: "my-empty-score"
    }, [_vm._v(_vm._s(_vm.MESSAGES.emptyScore))])])])])]) : _vm._e(), _vm._v(" "), (_vm.isTotal) ? _c('div', [_c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("合格者" + _vm._s(_vm.MESSAGES[dataKey]) + "点")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].score)) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm._f("score")(_vm.mydata.max)) + "点")])])]), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("\n                あなたの自己採点得点\n                "), _c('dn-icon', {
      staticClass: "my-box__icon-self",
      attrs: {
        "icon": "self",
        "btn": "",
        "href": _vm.selfUrl,
        "target": "_blank",
        "title": (_vm.year + "年度 自己採点")
      }
    })], 1), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [(_vm.hasTotals) ? _c('div', [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm.totalHistory.score) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.totalHistory.max) + "点")])]) : _c('div', [_c('span', {
      staticClass: "my-empty-score"
    }, [_vm._v(_vm._s(_vm.MESSAGES.emptyScore))]), _vm._v(" "), _c('dn-icon', {
      staticClass: "my-empty-icon",
      attrs: {
        "icon": "question",
        "btn": "",
        "title": "自己採点について"
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showSelfCheckDialog($event)
        }
      }
    })], 1)])]), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("個別試験で何点取れるか入れよう")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body"
    }, [_c('input', {
      directives: [{
        name: "number-range",
        rawName: "v-number-range"
      }, {
        name: "model",
        rawName: "v-model.lazy",
        value: (_vm.inputSingleScore[dataKey]),
        expression: "inputSingleScore[dataKey]",
        modifiers: {
          "lazy": true
        }
      }],
      staticClass: "my-single-score-input",
      attrs: {
        "type": "number",
        "min": "0",
        "max": _vm.mydata.singleMax
      },
      domProps: {
        "value": (_vm.inputSingleScore[dataKey])
      },
      on: {
        "change": [function($event) {
          _vm.$set(_vm.inputSingleScore, dataKey, $event.target.value)
        }, function($event) {
          _vm.onChangeSingleScore($event, dataKey)
        }]
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.mydata.singleMax) + "点")])])]), _vm._v(" "), _c('hr', {
      staticClass: "dn-divider-tri--down"
    }), _vm._v(" "), _c('dl', {
      staticClass: "my-box"
    }, [_c('dt', {
      staticClass: "my-box__header"
    }, [_vm._v("センター試験であと何点伸ばそう")]), _vm._v(" "), _c('dd', {
      staticClass: "my-box__body my-accent-num",
      class: ( _obj$1 = {}, _obj$1[("my-color-" + (_vm.mydata[dataKey].need <= 1 && _vm.mydata[dataKey].need !== null ? 'success' : 'alert'))] = true, _obj$1 )
    }, [_c('span', {
      staticClass: "my-wrap"
    }, [_vm._v(_vm._s(_vm._f("score")(_vm.mydata[dataKey].need)) + "点")]), _c('span', {
      staticClass: "my-wrap"
    }, [_vm._v("/" + _vm._s(_vm.mydata.max - _vm.mydata.singleMax) + "点")])])])]) : _vm._e()])])
    var _obj;
    var _obj$1;
  }), _vm._v(" "), _c('div', {
    staticClass: "my-annotation"
  }, [_c('p', [_vm._v("※このデータは、" + _vm._s(_vm.year) + "年７月までに弊社が収集した各大学公表の情報を元に作成しており、合格最低点・平均点が公表されている募集単位のみ掲載しています。")]), _vm._v(" "), _c('p', [_vm._v("※「センター試験であと何点伸ばそう」の点数はあくまでも参考点です。この点数を伸ばすと必ず志望大に合格するといったものではありません。")])])], 2), _vm._v(" "), _c('section', {
    staticClass: "mt30"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("どの教科・科目で伸ばすか？")]), _vm._v(" "), _c('p', [_vm._v("センター試験平均点と自己採点結果を比較し、差の大きい教科・科目から優先的に学習しよう")]), _vm._v(" "), _c('div', {
    staticClass: "tac mt40"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": "",
      "primary": "",
      "width-lg": "",
      "href": _vm.avgScoreInfoUrl,
      "target": "_blank"
    }
  }, [_vm._v("平均点情報")])], 1)])]), _vm._v(" "), _c('dn-dialog', {
    ref: "selfCheckDialog"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("自己採点結果が入力されていません。")]), _vm._v(" "), _c('p', [_vm._v("「"), _c('a', {
    attrs: {
      "href": ("../self/index.html?year=" + _vm.year)
    }
  }, [_vm._v("過去のセンター試験の自己採点をする")]), _vm._v("」から、自己採点を行ってください。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs.selfCheckDialog.hide($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my-empty__footer"
  }, [_c('dt', [_vm._v("主催")]), _vm._v(" "), _c('dd', [_vm._v("データネット実行委員会"), _c('wbr'), _vm._v("ベネッセコーポレーション"), _c('wbr'), _vm._v("／駿台予備学校")])])
}]}

/***/ }),

/***/ 860:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pg-app"
    }
  }, [_c('dn-db-downloader', {
    ref: "downloader",
    staticClass: "mb20",
    attrs: {
      "target": "@offers"
    },
    on: {
      "data-ready": _vm.onDataReady
    },
    model: {
      value: (_vm.downloadStatus),
      callback: function($$v) {
        _vm.downloadStatus = $$v
      },
      expression: "downloadStatus"
    }
  }), _vm._v(" "), (_vm.offer) ? _c('div', [_c('h2', {
    staticClass: "my-offer-head mdTtl02 mb20"
  }, [_c('span', {
    staticClass: "my-offer-name"
  }, [_vm._v(_vm._s(_vm.offer.university_name))]), _vm._v(" "), _c('span', {
    staticClass: "my-offer-meta-list"
  }, _vm._l((_vm.displayItemDetailKeys), function(key) {
    return (_vm.offer[key]) ? _c('span', {
      key: key,
      staticClass: "my-offer-meta"
    }, [_vm._v("　" + _vm._s(_vm.offer[key]))]) : _vm._e()
  }))]), _vm._v(" "), _c('dn-tabs', {
    attrs: {
      "id": "pg-tabs-1"
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('dn-tabs-bar', {
    attrs: {
      "slot": "activators"
    },
    slot: "activators"
  }, _vm._l((_vm.years), function(year) {
    return _c('dn-tabs-item', {
      key: year,
      staticClass: "pg-tab-year",
      attrs: {
        "href": '#pg-tabs-1-' + year
      }
    }, [_vm._v(_vm._s(year) + "年度"), _c('span', {
      staticClass: "pg-tab-year-pos"
    }, [_vm._v("入試")])])
  })), _vm._v(" "), _vm._l((_vm.years), function(year) {
    return _c('dn-tabs-content', {
      key: year,
      attrs: {
        "id": 'pg-tabs-1-' + year
      }
    }, [_c('my-year', {
      attrs: {
        "year": year,
        "offer": _vm.offer,
        "score": _vm.getScoreByYear(year)
      }
    })], 1)
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })

/******/ });


// WEBPACK FOOTER //
// bible/myuniv/js/score.js